class CartCompatibility extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");

    this.querySelector(".cart-compatibility__dismiss").addEventListener(
      "click",
      () => {
        this.details.open = false;
      }
    );
  }
}

if (!customElements.get("cart-compatibility")) {
  customElements.define("cart-compatibility", CartCompatibility);
}
